import React from "react";
import { useLocation } from "react-router-dom";


const CricketGearsList = () => {
  let location = useLocation();
  //console.log("first", location.state.item);
  const { item } = location.state;
  return (
    <ul>
    <li><strong>Name: </strong>{item.name}</li>
    <li><strong>Email: </strong>{item.email}</li>
    <li><strong>Type: </strong>{item.type}</li>
    <li><strong>Brand: </strong>{item.brand}</li>
    <li><strong>Size: </strong>{item.size}</li>
    </ul>
       
  );
};

export default CricketGearsList;
